export var Permissions;
(function (Permissions) {
    Permissions["LIMITED_VAULT_USER"] = "limited user";
    Permissions["BASIC_VAULT_USER"] = "basic user";
    Permissions["ADVANCED_VAULT_USER"] = "advanced user";
    Permissions["VAULT_ADMIN"] = "vault admin";
})(Permissions || (Permissions = {}));
